import { memo } from "react";

import { LandingPageEditorModalButton } from "./LandingPageEditorModalButton";
import { LandingPageLinkModalButton } from "./LandingPageLinkModalButton";

interface LandingPageButtonsProps {
  value?: any;
  isEditing?: boolean;
  data: any;
}
export const LandingPageButtons = memo(
  ({ value, isEditing, data, ...props }: LandingPageButtonsProps) => {
    if (isEditing) return null;

    return (
      <div className="d-flex flex-column align-items-start gap-1">
        <LandingPageEditorModalButton campaignId={value} />
        <LandingPageLinkModalButton campaignId={value} />
      </div>
    );
  },
);
